import React from 'react'
import styled from 'styled-components'
import Waypoint from 'react-waypoint'
import { clearFix } from 'polished'

import { fadeIn } from '../../../animations'
import Image from '../../common/Image'

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  margin: 50px auto;

  &:first-of-type,
  &:last-of-type {
    margin: 0 auto;
  }

  h3 {
    color: ${props => props.theme.secondary.bg3};
    text-transform: capitalize;
    font-size: 2.2em;
  }

  .tour-gallery-category-inner {
    max-width: 60em;
    margin: 0 auto;
  }
`

const Blocks = styled.div`
  .tour-gallery-category-block {
    opacity: 0;
    background-color: #fff;
    border-radius: 3px;
    padding: 1.5em 1em;
    margin-bottom: 2em;

    h4 {
      color: ${props => props.theme.main.bg};
      margin: 0;
      font-weight: 400;
      font-size: 1.5em;
    }

    img {
      width: 100%;
      height: auto;
      border-radius: 3px;
      display: block;
    }

    p {
      margin: 0.5em 0 1em;
      color: #2b2b2b;
    }

    @media screen and (min-width: 801px) {
      padding: 2em;
    }
  }
`

class Block extends React.PureComponent {
  waypointEnter = this.waypointEnter.bind(this)

  waypointEnter() {
    fadeIn(this.block, 0.5)
  }

  render() {
    return (
      <div ref={el => (this.block = el)} className="tour-gallery-category-block">
        <Waypoint onEnter={this.waypointEnter} topOffset="-50%" />
        {this.props.children}
      </div>
    )
  }
}

const GalleryMainCategory = ({ subcategory }) => {
  const children = subcategory[1].items
  const blocks = Object.entries(children).map(block => block[1])
  return (
    <Wrapper className="tour-gallery-category">
      <div className="tour-gallery-category-inner">
        <h3>{subcategory[1].name}</h3>
        <Blocks>
          {blocks.map((block, i) => (
            <Block key={i}>
              <h4>{block.name}</h4>
              <p>{block.caption}</p>
              <Image
                sizes="(max-width: 800px) 800px, 1600px"
                src={block.src}
                srcSet={`
                  ${block.srcMobile} 800w,
                  ${block.src} 1600w
                `}
                alt={block.alt}
              />
            </Block>
          ))}
        </Blocks>
      </div>
    </Wrapper>
  )
}

export default GalleryMainCategory



// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/gallery/GalleryMainCategory.js